import BaseService from "@/boot/BaseService";
class ObraService extends BaseService {
  constructor() {
    super(null, "/obras");
  }
  async index(params) {
    return await this.get("/", params);
  }
  async show(id) {
    return await this.get(`/${id}`);
  }

  async store(formData) {
    return await this.post("", formData);
  }

  async update(id,formData) {
    return await this.put(`/${id}`, formData);
  }

  async list(filter, cliente) {
    return await this.post("/list", { filter, cliente });
  }

  async presupuestos(obra) {
    return await this.get(`/${obra}/presupuestos`);
  }
}

export default new ObraService();
